import * as yup from "yup";

const dateFilterValidationSchema = yup.object().shape({
  date: yup.string().required(),
});

export default dateFilterValidationSchema;
